module.exports = __webpack_public_path__ + "img/product_chart_3.ca875ef3.png";